import { render, staticRenderFns } from "./ListagemBanner.vue?vue&type=template&id=4ffb14c6"
import script from "./ListagemBanner.vue?vue&type=script&lang=js"
export * from "./ListagemBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports